import {
  OPEN_MODAL,
  CLOSE_MODAL
} from 'shared/actions/types';

export const openModal = id => dispatch => {
  dispatch({
    type: OPEN_MODAL,
    payload: { id }
  });
}

export const closeModal = id => dispatch => {
  dispatch({
    type: CLOSE_MODAL,
    payload: { id }
  });
}
